import "./Login.scss";

import {
  Container,
  Grid,
  isWidthDown,
  Typography,
  withWidth,
} from "@material-ui/core";
import { ApiErrors } from "common/backend/api-errors/errors";
import { CommonErrorDialog } from "common/components/CommonErrorDialog";
import { SubmitButton } from "common/components/input/elements";
import { UserField, UserInputTypeKey } from "common/components/input/fields";
import { LoginUser } from "common/graphql/queryDescriptors";
import { useCustomQuery } from "common/store/hooks/useCustomQuery";
import { LoginUserManageable } from "common/store/user/types";
import { errorMessages } from "common/utils/validation";
import { Form, Formik } from "formik";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

function Login({ width }: any) {
  // State
  const [error, setError] = useState("");

  // Hooks
  const history = useHistory();
  const { t } = useTranslation();

  const { execute: login } = useCustomQuery(LoginUser({
    onSuccess: () => {
      history.push("/landing");
    },
    onError: (error: ApiErrors) => {
      if (error === ApiErrors.USER_INVALID_CREDENTIALS) {
        setError(t("Wrong email or password"));
      }
    },
  }));

  // Options
  const initialValues = new LoginUserManageable();

  // Validation
  const onValidate = (values: LoginUserManageable) => {
    return new LoginUserManageable(values).validate(
      Object.keys(values),
      errorMessages
    );
  };

  const onSubmit = async (values: LoginUserManageable) => {
    await login({ variables: { input: new LoginUserManageable(values).serialize() } });
  };

  return (
    <>
      <Formik
        initialValues={initialValues}
        validate={onValidate}
        onSubmit={onSubmit}
      >
        {({
          values,
          errors,
          isSubmitting,
          touched,
          setFieldValue,
          setValues,
          submitForm,
        }) => {
          const props = {
            values,
            errors,
            isSubmitting,
            touched,
            setFieldValue,
            setValues,
            submitForm,
          };

          const buttonProps = { ...props } as any;
          delete buttonProps.setFieldValue;
          delete buttonProps.setValues;

          const fieldProps = { ...props } as any;
          delete fieldProps.submitForm;
          delete fieldProps.isSubmitting;

          return (
            <Form className="login">
              <Container
                className={
                  isWidthDown(
                    "xs",
                    width
                  ) ? "container--mobile" : "container"
                }
              >
                <Grid container spacing={6}>
                  <Grid item xs={12}>
                    <Typography className="title" color="primary">
                      {t("Log in")}
                    </Typography>
                  </Grid>

                  <Grid item xs={12}>
                    <UserField id={"email" as UserInputTypeKey} {...fieldProps} />
                  </Grid>

                  <Grid item xs={12}>
                    <UserField id={"password" as UserInputTypeKey} {...fieldProps} />
                  </Grid>

                  <Grid item xs={6}>
                    <SubmitButton
                      value={t("Log in")}
                      {...buttonProps}
                    />
                  </Grid>
                </Grid>
              </Container>
            </Form>
          );
        }}
      </Formik>

      <CommonErrorDialog error={error} setError={setError} />
    </>
  );
}

export default withWidth()(Login);